import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-customer-detail-modal',
  templateUrl: './customer-detail-modal.component.html',
  styleUrls: ['./customer-detail-modal.component.css']
})
export class CustomerDetailModalComponent implements OnInit {
  
  @Input() customerDetail:any;
  @Output() closeModal = new EventEmitter<any>();


  constructor(){}

  ngOnInit(): void {
    console.log('customerDetail', this.customerDetail);
      
  }

  onCloseModal(){
    this.closeModal.emit();
  }

}
